import { Turbo } from '@hotwired/turbo-rails';

const { StreamActions } = Turbo;

// eslint-disable-next-line func-names
StreamActions.reload = function () {
  window.location.reload();
};
